import { render, staticRenderFns } from "./ResourceDescription.vue?vue&type=template&id=42d3a651"
import script from "./ResourceDescription.vue?vue&type=script&lang=ts"
export * from "./ResourceDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports